import { reducedStream, reducer } from '@ardoq/rxbeach';
import {
  graphViewLegendHighlightComponentType,
  graphViewLegendHighlightConditionalFormatting,
  graphViewLegendHighlightReferenceType,
  graphViewLegendSetSelectedComponentTypes,
  graphViewLegendSetSelectedConditionalFormatting,
  graphViewLegendSetSelectedReferenceTypes,
  GraphViewLegendComponentTypePayload,
  GraphViewLegendComponentTypesPayload,
  GraphViewLegendConditionalFormattingPayload,
  GraphViewLegendConditionalFormattingsPayload,
  GraphViewLegendReferenceTypePayload,
  GraphViewLegendReferenceTypesPayload,
} from 'tabview/graphViews/graphViewLegend/actions';
import type { LegendComponentType, LegendReferenceType } from '@ardoq/graph';

export type InteractiveRelationshipsViewLegendState = {
  selectedComponentTypes: string[][];
  selectedReferenceTypes: string[][];
  selectedConditionalFormattingIds: string[];
  highlightedComponentType: LegendComponentType | null;
  highlightedReferenceType: LegendReferenceType | null;
  highlightedConditionalFormattingId: string | null;
};

const INITIAL_STATE: InteractiveRelationshipsViewLegendState = {
  selectedComponentTypes: [],
  selectedReferenceTypes: [],
  selectedConditionalFormattingIds: [],
  highlightedComponentType: null,
  highlightedReferenceType: null,
  highlightedConditionalFormattingId: null,
};

const setSelectedComponentTypes = (
  state: InteractiveRelationshipsViewLegendState,
  { componentTypes }: GraphViewLegendComponentTypesPayload
): InteractiveRelationshipsViewLegendState => ({
  ...state,
  selectedComponentTypes: componentTypes.map(({ ids }) => ids),
});

const setSelectedReferenceTypes = (
  state: InteractiveRelationshipsViewLegendState,
  { referenceTypes }: GraphViewLegendReferenceTypesPayload
): InteractiveRelationshipsViewLegendState => ({
  ...state,
  selectedReferenceTypes: referenceTypes.map(
    ({ globalTypeIds }) => globalTypeIds
  ),
});

const setSelectedConditionalFormattingIds = (
  state: InteractiveRelationshipsViewLegendState,
  { ids }: GraphViewLegendConditionalFormattingsPayload
): InteractiveRelationshipsViewLegendState => ({
  ...state,
  selectedConditionalFormattingIds: ids,
});

const setHighlightedComponentType = (
  state: InteractiveRelationshipsViewLegendState,
  { componentType }: GraphViewLegendComponentTypePayload
): InteractiveRelationshipsViewLegendState => ({
  ...state,
  highlightedComponentType: componentType,
});

const setHighlightedReferenceType = (
  state: InteractiveRelationshipsViewLegendState,
  { referenceType }: GraphViewLegendReferenceTypePayload
): InteractiveRelationshipsViewLegendState => ({
  ...state,
  highlightedReferenceType: referenceType,
});

const setHighlightedConditionalFormatting = (
  state: InteractiveRelationshipsViewLegendState,
  { id }: GraphViewLegendConditionalFormattingPayload
): InteractiveRelationshipsViewLegendState => ({
  ...state,
  highlightedConditionalFormattingId: id,
});

const interactiveRelationshipsViewLegendState$ = reducedStream(
  'interactiveRelationshipsViewLegendState$',
  INITIAL_STATE,
  [
    reducer(
      graphViewLegendSetSelectedComponentTypes,
      setSelectedComponentTypes
    ),
    reducer(
      graphViewLegendSetSelectedReferenceTypes,
      setSelectedReferenceTypes
    ),
    reducer(
      graphViewLegendSetSelectedConditionalFormatting,
      setSelectedConditionalFormattingIds
    ),
    reducer(graphViewLegendHighlightComponentType, setHighlightedComponentType),
    reducer(graphViewLegendHighlightReferenceType, setHighlightedReferenceType),
    reducer(
      graphViewLegendHighlightConditionalFormatting,
      setHighlightedConditionalFormatting
    ),
  ]
);

export {
  interactiveRelationshipsViewLegendState$,
  INITIAL_STATE as EMPTY_INTERACTIVE_RELATIONSHIPS_VIEW_LEGEND_STATE,
};
